<template>
  <div class="resultSignature_warpper">
    <nav-bar titleText="签约完成" titleWeight="bold" @goBack="closeContractSigned"></nav-bar>
    <results-page @handleOperationClick="closeContractSigned" @handleReturnClick="closeContractSigned" operationDisplab
      operationText="完成" returnDisplab returnText="返回" :imgSrc="imgSrc" instructions="已完成签约"></results-page>
  </div>
</template>
<script>
  import navBar from "../components/navBar";
  import resultsPage from "../../debtRelief/components/resultsPage";
  export default {
    data() {
      return {
        imgSrc: require("../../../assets/debtor/resultOk.png")
      };
    },
    created() {},
    components: {
      navBar,
      resultsPage,
    },
    methods: {
      closeContractSigned() {
        this.params('success', 'success', 'closeContractSigned');
      },
      // handleOperationClick() {
      //   this.params('success', 'success', 'closeContractSigned');
      // },
      // handleReturnClick() {
      //   this.params('success', 'success', 'closeContractSigned');
      // }
    }
  }
</script>
<style lang="less">
  .resultSignature_warpper {
    padding-top: 88px;
    box-sizing: border-box;
    background-color: #f5f6f7;
    min-height: 100%;
    font-size: 16px;
    color: #333;
  }

  .return {
    display: none !important;
  }
</style>